// Modules
import useVersionCheck from 'hooks/useVersionCheck';

// UI
import {
  Navbar,
  NavbarDivider,
  NavbarItem,
  NavbarSection,
  NavbarSpacer,
} from 'components/catalyst/navbar';
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarSection,
} from 'components/catalyst/sidebar';
import {StackedLayout} from 'components/catalyst/stacked-layout';
import {Outlet} from 'react-router-dom';
import UserMenu from './UserMenu';
import pomboLogo from 'images/pombologo.webp';

const navItems = [{label: 'Home', url: '/customers'}];

export const CustomerLayout = () => {
  // Check if app version changed - forces logout if updated
  useVersionCheck();

  return (
    <StackedLayout
      navbar={
        <Navbar>
          <img src={pomboLogo} className="w-32" alt='logo' />
          <NavbarDivider className="max-lg:hidden" />
          <NavbarSection className="max-lg:hidden">
            {navItems.map(({label, url}) => (
              <NavbarItem key={label} href={url}>
                {label}
              </NavbarItem>
            ))}
          </NavbarSection>
          <NavbarSpacer />
          <NavbarSection>
            <UserMenu noButtons navigateOnLogout="/customers/login" />
          </NavbarSection>
        </Navbar>
      }
      sidebar={
        <Sidebar>
          <SidebarHeader>
            <img src={pomboLogo} className="w-32 h-16" alt="Company Logo" />
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
              {navItems.map(({label, url}) => (
                <SidebarItem key={label} href={url}>
                  {label}
                </SidebarItem>
              ))}
            </SidebarSection>
          </SidebarBody>
        </Sidebar>
      }>
      <Outlet />
    </StackedLayout>
  );
};
